let [WAPAPI, PCAPI, ROOTAPI] = [ '', '', '' ];
if(process.env.REACT_APP_PROJECT_ENV === 'production' && process.env.NODE_ENV === 'production') {
    WAPAPI = 'https://m.ibuychem.com';
    PCAPI = 'https://www.ibuychem.com/';
    ROOTAPI = '//www.ihuijiaju.com/';
} else {
    WAPAPI = 'https://m-stg.ibuychem.com';
    PCAPI = 'https://www-stg.ibuychem.com/';
    ROOTAPI = '//www-stg.ihuijiaju.com/';
}
 
export default {
    WAPAPI,
    PCAPI,
    ROOTAPI
}


// WEBPACK FOOTER //
// ./src/config/config.ts